import { Verification } from "../../../services/verifyService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class DeductibleMetMustBeLessThanDeductible extends CompositeSpecification<Verification>{
    IsSatisfiedBy(candidate: Verification): boolean {
        return Number(candidate.benefits.deductibleMet) <= Number(candidate.benefits.deductible);
    }

}